<template>
  <div class="field">
    <span v-if="label"><strong>{{ label }}: </strong></span>
    <div class="p-inputgroup">
      <Dropdown
        :modelValue="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        :options="promocionesDisponibles"
        optionLabel="label"
        optionValue="value"
        :filter="true"
        :placeholder="placeholder"
        :disabled="disabled || cargando"
        :loading="cargando"
      >
        <template #option="slotProps">
          <div class="p-dropdown-car-option">
            <span>{{ slotProps.option.label }}</span>
          </div>
        </template>
      </Dropdown>
    </div>
  </div>
</template>

<script>
import PaqueteProductoService from '@/service/PaqueteProductoService';

export default {
  name: 'SelectPromociones',
  props: {
    modelValue: {
      type: [String, Number],
      required: false
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Seleccione una Promoción/Paquete'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    mostrarTodos: {
      type: Boolean,
      default: false
    },
    // Propiedad para recibir el grupoId
    grupoId: {
      type: [String, Number],
      default: null
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      promocionesDisponibles: [],
      cargando: false,
      paqueteService: new PaqueteProductoService()
    }
  },
  mounted() {
    this.cargarPromociones();
  },
  watch: {
    // Escucha cambios en grupoId para recargar el dropdown si cambia el grupo
    grupoId: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.cargarPromociones();
        }
      }
    }
  },
  methods: {
    async cargarPromociones() {
      this.cargando = true;
      try {
        // Pasamos this.grupoId al servicio, será null si no se envía el prop
        const response = await this.paqueteService.getPaquetePorGrupoSelect(this.grupoId);
        
        // Tratamos de buscar el array de resultados según como retorne el backend
        let data = Array.isArray(response) 
          ? response 
          : (response.data || response.paquete_productos || response.paquetes || Object.values(response).find(Array.isArray) || []);
        
        if (data && data.length >= 0) {
          this.promocionesDisponibles = data.map(paquete => {
            return {
              value: paquete.id,
              label: paquete.nombre || paquete.descripcion // Ajusta si la propiedad se llama diferente
            };
          });
          
          if (this.mostrarTodos) {
            this.promocionesDisponibles.unshift({ value: null, label: "TODOS" });
          }
          
          if (this.modelValue === undefined && this.promocionesDisponibles.length > 0) {
            this.$emit('update:modelValue', this.promocionesDisponibles[0].value);
          }
        }
      } catch (error) {
        console.error("Error cargando promociones para el Dropdown:", error);
      } finally {
        this.cargando = false;
      }
    }
  }
}
</script>

<style scoped>
</style>
